export default "__VITE_ASSET__BaR3HT42__"